const s = {
  ctaButtonText: "+ Viac"
};
export {
  s as c
};
//# sourceMappingURL=carousel.messages-243a8ce8.js.map
